export default __webpack_public_path__ + "static/media/cc.5ca31cb4.svg";